import { call, put } from "redux-saga/effects";

import { getReseBmsTableDataSuccess, getReseBmsTableDataError, getReseBmsTableDanfossVersionFirmwareSuccess, getReseBmsTableDanfossVersionFirmwareError, getReseBmsTableEmersonVersionFirmwareSuccess, getReseBmsTableEmersonVersionFirmwareError, getReseBmsTableStatusSuccess, 
getReseBmsTableStatusError, updateReseBmsTableDataSuccess, updateReseBmsTableDataError,getReseBmsTableDataInit } from "../components/rese/bms/redux/actions";
import { getReseBmsTableData, getReseBmsTableDistinctColumnData, getReseBmsVersionAndFirmwareColumnData, updateReseBmsTableData } from "../components/rese/bms/ReseBmsService";

export function* loadReseBmsTableData ({pageNumber, pageSize, sortBy, sortDirection, filterCondition}) {
    try {
        const reseBmsTableData = yield call(getReseBmsTableData, pageNumber, pageSize, sortBy, sortDirection, filterCondition);
        yield put(getReseBmsTableDataSuccess(reseBmsTableData));
    }
    catch (error) {
        yield put(getReseBmsTableDataError(error.toString()));
    }
}

export function* loadReseBmsTableDanfossVersionFirmwareData ({brandName}) {
    try {
        const DanfossversionAndFirmwareData = yield call(getReseBmsVersionAndFirmwareColumnData, brandName);
        yield put(getReseBmsTableDanfossVersionFirmwareSuccess(DanfossversionAndFirmwareData));
    }
    catch(error) {
        yield put(getReseBmsTableDanfossVersionFirmwareError(error.toString()));
    }
}

export function* loadReseBmsTableEmersonVersionFirmwareData ({brandName}) {
    try {
        const EmersonversionAndFirmwareData = yield call(getReseBmsVersionAndFirmwareColumnData, brandName);
        yield put(getReseBmsTableEmersonVersionFirmwareSuccess(EmersonversionAndFirmwareData));
    }
    catch(error) {
        yield put(getReseBmsTableEmersonVersionFirmwareError(error.toString()));
    }
}

export function* loadReseBmsTableStatusData ({statusColumnPayload}) {
    try {
        const reseBmsTableStatus = yield call(getReseBmsTableDistinctColumnData, statusColumnPayload);
        yield put(getReseBmsTableStatusSuccess(reseBmsTableStatus));
    }
    catch(error) {
        yield put(getReseBmsTableStatusError(error.toString()));
    }
}

export function* updateBmsTableData ({resebmstableData}) {
    try {
        const reseBmsTableDataUpdateMessage = yield call(updateReseBmsTableData, resebmstableData);
        yield put(updateReseBmsTableDataSuccess(reseBmsTableDataUpdateMessage));
        yield put(getReseBmsTableDataInit(0, 10, "storeId", "ASC", ""));

    }
    catch(error) {
        yield put(updateReseBmsTableDataError(error.toString()));
    }
}